var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSessionsCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9662 8.71802V2.5C21.0681 2.84867 25.3285 6.25818 26.9255 10.9061L20.9264 12.5137C20.072 10.5021 18.2056 9.02432 15.9662 8.71802ZM20.1041 18.8564L25.4696 21.9542C23.2238 25.2817 19.4181 27.4698 15.1016 27.4698C13.1329 27.4698 11.2708 27.014 9.61434 26.2033L12.7095 20.8424C13.4475 21.1441 14.255 21.3109 15.1016 21.3109C17.1366 21.3109 18.9472 20.3496 20.1041 18.8564ZM27.6016 14.9698C27.6016 16.9385 27.1458 18.8003 26.3351 20.457L20.9669 17.3576C21.2637 16.6249 21.4273 15.8239 21.4273 14.9849C21.4273 14.7134 21.41 14.446 21.3768 14.1834L27.3716 12.5771C27.5222 13.3516 27.6016 14.1513 27.6016 14.9698ZM11.2133 19.9747L8.11712 25.3378C4.78965 23.0917 2.60156 19.2863 2.60156 14.9698C2.60156 8.35694 7.73687 2.9442 14.2369 2.5V8.71802C11.1523 9.13982 8.77559 11.7845 8.77559 14.9849C8.77559 17.0124 9.72958 18.8173 11.2133 19.9747Z",
    fill: "#F59E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionsCompleted);
export default __webpack_public_path__ + "static/media/SessionsCompleted.ac768766ffc65dc85e677086066cdf6d.svg";
export { ForwardRef as ReactComponent };